import { Box, Typography, Grid, Paper, Button } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import Layout from "../components/layout/LandingPageLayout";
import { Link } from "react-router-dom";

const MsmeInfo = () => {
  const theme = useTheme();

  return (
    <Layout>
      <Box
        sx={{
          py: 8,
          px: 4,
          backgroundColor: theme.palette.background.default,
        }}
      >
        {/* Title */}
        <Typography
          variant="h4"
          align="center"
          gutterBottom
          sx={{ fontWeight: "bold", color: theme.palette.primary.main }}
        >
          Empowering MSMEs with Smart Accounting
        </Typography>

        <Typography
          variant="body1"
          align="center"
          sx={{
            maxWidth: 700,
            mx: "auto",
            color: theme.palette.text.secondary,
            mb: 6,
          }}
        >
          Our AI Accountant is designed to help Micro, Small, and Medium
          Enterprises save time, reduce costs, and stay compliant with smart
          automation and real-time financial insights.
        </Typography>

        {/* MSME Benefits */}
        <Grid container spacing={4} justifyContent="center">
          <Grid item xs={12} sm={4}>
            <Paper
              elevation={3}
              sx={{
                p: 4,
                textAlign: "center",
                borderRadius: 3,
                transition: "0.3s",
                "&:hover": { transform: "translateY(-6px)", boxShadow: 6 },
              }}
            >
              <TrendingUpIcon
                sx={{ fontSize: 50, color: theme.palette.primary.main, mb: 2 }}
              />
              <Typography variant="h6" gutterBottom>
                Growth Insights
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Get AI-powered balance sheets, profit & loss reports, and cash
                flow analysis to make smarter growth decisions.
              </Typography>
            </Paper>
          </Grid>

          <Grid item xs={12} sm={4}>
            <Paper
              elevation={3}
              sx={{
                p: 4,
                textAlign: "center",
                borderRadius: 3,
                transition: "0.3s",
                "&:hover": { transform: "translateY(-6px)", boxShadow: 6 },
              }}
            >
              <AccessTimeIcon
                sx={{ fontSize: 50, color: theme.palette.primary.main, mb: 2 }}
              />
              <Typography variant="h6" gutterBottom>
                Save Time
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Automate bookkeeping, invoicing, and compliance so you can focus
                on growing your business instead of paperwork.
              </Typography>
            </Paper>
          </Grid>

          <Grid item xs={12} sm={4}>
            <Paper
              elevation={3}
              sx={{
                p: 4,
                textAlign: "center",
                borderRadius: 3,
                transition: "0.3s",
                "&:hover": { transform: "translateY(-6px)", boxShadow: 6 },
              }}
            >
              <AccountBalanceIcon
                sx={{ fontSize: 50, color: theme.palette.primary.main, mb: 2 }}
              />
              <Typography variant="h6" gutterBottom>
                Stay Compliant
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Avoid penalties with automated GST, tax filings, and compliance
                reminders tailored for MSMEs.
              </Typography>
            </Paper>
          </Grid>
        </Grid>

        {/* CTA */}
        <Box textAlign="center" mt={6}>
          <Button
            component={Link}
            to="/login"
            variant="contained"
            size="large"
            sx={{
              backgroundColor: theme.palette.primary.main,
              "&:hover": { backgroundColor: theme.palette.primary.dark },
              px: 5,
              py: 1.5,
              borderRadius: 3,
              textTransform: "none",
              fontWeight: "bold",
            }}
          >
            Start Your MSME AI Journey
          </Button>
        </Box>
      </Box>
    </Layout>
  );
};

export default MsmeInfo;
